



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import FlightInput from "@/store/entities/flight/flightInput";
import Currency from "@/store/entities/currency";
import AirlineCompany from "@/store/entities/flight/airlineCompany";
import Aircraft from "@/store/entities/flight/aircraft";
import Airport from "@/store/entities/flight/airport";
import FlightProvider from "@/store/entities/flight/flightProvider";
import FlightPriceGeneral from "@/store/entities/flight/flightPriceGeneral";
import FlightClass from "@/store/entities/flight/flightClass";
import FlightSegment from "@/store/entities/flight/flightSegment";
import PassengerType from "@/store/entities/passengerType";
import SalesChannels from "../definitions/salesChannels.vue";
import FlightSaleChannel from "@/store/entities/flight/flightSaleChannel";
import FlightPeriod from "@/store/entities/flight/flightPeriods";
import FlightGeneral from "@/store/entities/flight/flightGeneral";
import FlightRountTrip from "@/store/entities/flight/flightRountTrip";
import moment from "moment";
import rules from "@/Data/formRules";
import { ValidationObserver, ValidationProvider } from "vee-validate";

@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class FlightWizard extends Vue {
  today: string = "";
  displayAlert: boolean = false;
  type = "month";
  e1: number = 1;
  radios: boolean = true;
  flightTypes: number = 0;
  startDate: Date = null;
  endDate: Date = null;
  breadcrumbsItems: any[] = [];
  checkbox: boolean = false;
  headersPriceList: any[] = [];
  headersFlightRules: any[] = [];
  mockDataFlightRules: any[] = [];
  headersResultList: any[] = [];
  mockDataResultList: any[] = [];
  dataResultList: any[] = [];
  selected: any[] = [];
  focus = null;
  selectedOpen: boolean = false;
  selectedEvent: object = {};
  selectedElement = null;
  active_tab: number = 0;
  events: any[] = [];
  oneWay: boolean = true;
  rt: boolean = false;
  colors: any[] = [];
  names: any[] = [];
  days: any = [];
  flightQuotas: any[] = [];
  flightInput: FlightInput = new FlightInput();
  flightInputRt: FlightRountTrip = new FlightRountTrip();
  departureMenu: boolean = false;
  departureMenu2: boolean = false;
  endDateMenu: boolean = false;
  flightInputEd: FlightInput = new FlightInput();
  flightInputEd2: FlightInput = new FlightInput();
  arrivalMenu: boolean = false;
  currencies: Currency[] = [];
  airlineCompanies: AirlineCompany[] = [];
  aircrafts: Aircraft[] = [];
  airports: Airport[] = [];
  flightProviders: FlightProvider[] = [];
  flightClasses: FlightClass[] = [];
  flightSegments: FlightSegment[] = [];
  flightSaleChannels: FlightSaleChannel[] = [];
  mockDataPriceList: any[] = [];
  flightPricesOw: FlightPriceGeneral[] = [];
  flightPricesOwRt: FlightPriceGeneral[] = [];
  adultPriceOw: FlightPriceGeneral = new FlightPriceGeneral();
  childPriceOw: FlightPriceGeneral = new FlightPriceGeneral();
  infantPriceOw: FlightPriceGeneral = new FlightPriceGeneral();
  adultPriceOwRt: FlightPriceGeneral = new FlightPriceGeneral();
  childPriceOwRt: FlightPriceGeneral = new FlightPriceGeneral();
  infantPriceOwRt: FlightPriceGeneral = new FlightPriceGeneral();
  flightPeriods: FlightPeriod[] = [];
  flightPeriodsRt: FlightPeriod[] = [];
  flightDestinations: any[] = [];
  flightDestination: string = "";
  dialog: boolean = false;
  isFlightRt: boolean = false;
  setDepartureDate: string;
  index: number | string = 0;
  minDepartureDate = new Date().toISOString().slice(0, 10);
  isBusinessFlight: boolean = false;

  $refs: {
    calendar: any;
  };

  async created() {
    this.getFlightProviders();
    this.getAirports();
    this.getCurrencies();
    this.getAirlineCompanies();
    this.createPriceOw();
    // this.createPriceOwRt();
    this.getFlightClasses();
    this.getFlightSegments();
    this.getFlightSaleChannels();
    this.setDepartureDate = this.getDepartureDate;
    (this.headersPriceList = [
      { text: "İşlemler", value: "" },
      { text: "Uçuş Sınıfı", value: "flightClass" },
      { text: "Uçak Bölümleri", value: "flightSegment" },
      { text: "Yolcu Türü", value: "passengerType" },
      { text: "Tek Yön Fiyatı", value: "oneWayPrice" },
      { text: "Gidiş-Dönüş Fiyatı", value: "roundTripPrice" },
      { text: "En Az Yaş", value: "minAge" },
      { text: "En Fazla Yaş", value: "maxAge" },
      { text: "Satış Kanalı", value: "salesChannel" },
    ]),
      (this.mockDataPriceList = [
        {
          flightClass: "ECONOMY",
          flightSegment: "Y",
          passengerType: "Yetişkin",
          oneWayPrice: "0.00",
          roundTripPrice: "0.00",
          limitedQuota: "0",
          minAge: "12",
          maxAge: "99",
          salesChannel: "internet",
        },
      ]),
      (this.headersFlightRules = [
        { text: "İşlemler", value: "" },
        { text: "Satış Kanalı", value: "salesChannel" },
        { text: "En Az Gün Sayısı", value: "minDay" },
        { text: "En Çok Gün Sayısı", value: "maxDay" },
        { text: "Hesaplama Türü", value: "calculationType" },
        { text: "Değer", value: "value" },
        { text: "Değişim Çeşidi", value: "typeOfChange" },
      ]),
      (this.mockDataFlightRules = [
        {
          salesChannel: "İnternet",
          minDay: "1",
          maxDay: "5",
          calculationType: "Miktar",
          value: "1",
          typeOfChange: "Zam",
        },
      ]),
      (this.headersResultList = [
        { text: "Başlangıç - Varış", value: "destination" },
        { text: "Havayolu Firması", value: "company" },
        { text: "Uçuş Numarası", value: "flightNo" },
        { text: "Kalkış Tarihi", value: "departureDate" },
        { text: "Fiyat", value: "price" },
        { text: "Kota", value: "rule" },
      ]),
      (this.mockDataResultList = [
        {
          destination: "ABA - ADA",
          company: "REDWINGSY",
          flightNo: "xxxx",
          departureDate: "06/05/2021 14:30",
          price: "var",
          rule: "var",
          quota: "var",
        },
      ]),
      (this.flightQuotas = [
        {
          flightClass: {
            name: this.isBusinessFlight ? "BUSINESS" : "ECONOMY",
            code: null,
            pricing: null,
            id: this.isBusinessFlight ? "B" : "X",
          },
          flightSegment: {
            name: this.isBusinessFlight ? "Z" : "Y",
            id: this.isBusinessFlight ? "B" : "A",
          },
          quota: "20",
        },
      ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Uçuş", disabled: true },
        { text: "Uçuş Ekleme Sihirbazı", disabled: true },
      ]);
  }

  prevFirstPage() {
    this.flightDestinations = [];
    this.e1 = 1;
  }

  showEvent({ nativeEvent, event }) {
    const open = () => {
      this.selectedEvent = event;
      this.selectedElement = nativeEvent.target;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => (this.selectedOpen = true))
      );
    };

    if (this.selectedOpen) {
      this.selectedOpen = false;
      requestAnimationFrame(() => requestAnimationFrame(() => open()));
    } else {
      open();
    }

    nativeEvent.stopPropagation();
  }

  viewDay(date) {
    if (date.color === "cyan") {
      this.events = this.events.filter((d) => d.start !== date.start);
      this.flightPeriods = this.flightPeriods.filter(
        (d) => d.startsAt !== date.start
      );
    } else {
      this.flightPeriodsRt = this.flightPeriodsRt.filter(
        (d) => d.startsAt !== date.start
      );
    }
    this.selectedOpen = false;
  }

  createPriceOw() {
    this.adultPriceOw.flightClass = new FlightClass();
    this.adultPriceOw.flightSegment = new FlightSegment();
    this.adultPriceOw.passengerType = new PassengerType();
    this.adultPriceOw.salesChannel = new FlightSaleChannel();
    this.adultPriceOw.flightClass.name = this.isBusinessFlight ? "BUSINESS" : "ECONOMY";
    this.adultPriceOw.flightClass.id = this.isBusinessFlight ? "B" : "X";
    this.adultPriceOw.flightSegment.name = this.isBusinessFlight ? "Z" : "Y";
    this.adultPriceOw.flightSegment.id = this.isBusinessFlight ? "B" : "A";
    this.adultPriceOw.passengerType.name = "Adult";
    this.adultPriceOw.passengerType.id = 1;
    this.adultPriceOw.salesChannel.name = "Internet";
    this.adultPriceOw.salesChannel.id = "INTERNET";
    this.adultPriceOw.oneWayPrice = "0";
    this.adultPriceOw.roundTripPrice = "0";
    this.adultPriceOw.minAge = "12";
    this.adultPriceOw.maxAge = "99";
    this.adultPriceOw.quota = this.flightInput.totalQuota;

    this.infantPriceOw.flightClass = new FlightClass();
    this.infantPriceOw.flightSegment = new FlightSegment();
    this.infantPriceOw.passengerType = new PassengerType();
    this.infantPriceOw.salesChannel = new FlightSaleChannel();
    this.infantPriceOw.flightClass.name = this.isBusinessFlight ? "BUSINESS" : "ECONOMY";
    this.infantPriceOw.flightClass.id = this.isBusinessFlight ? "B" : "X";
    this.infantPriceOw.flightSegment.name = this.isBusinessFlight ? "Z" : "Y";
    this.infantPriceOw.flightSegment.id = this.isBusinessFlight ? "B" : "A";
    this.infantPriceOw.passengerType.name = "Infant";
    this.infantPriceOw.passengerType.id = 3;
    this.infantPriceOw.salesChannel.name = "Internet";
    this.infantPriceOw.salesChannel.id = "INTERNET";
    this.infantPriceOw.oneWayPrice = "0";
    this.infantPriceOw.roundTripPrice = "0";
    this.infantPriceOw.minAge = "0";
    this.infantPriceOw.maxAge = "2";
    this.infantPriceOw.quota = this.flightInput.totalQuota;

    this.childPriceOw.flightClass = new FlightClass();
    this.childPriceOw.flightSegment = new FlightSegment();
    this.childPriceOw.passengerType = new PassengerType();
    this.childPriceOw.salesChannel = new FlightSaleChannel();
    this.childPriceOw.flightClass.name = this.isBusinessFlight ? "BUSINESS" : "ECONOMY";
    this.childPriceOw.flightClass.id = this.isBusinessFlight ? "B" : "X";
    this.childPriceOw.flightSegment.name = this.isBusinessFlight ? "Z" : "Y";
    this.childPriceOw.flightSegment.id = this.isBusinessFlight ? "B" : "A";
    this.childPriceOw.passengerType.name = "Child";
    this.childPriceOw.passengerType.id = 2;
    this.childPriceOw.salesChannel.name = "Internet";
    this.childPriceOw.salesChannel.id = "INTERNET";
    this.childPriceOw.oneWayPrice = "0";
    this.childPriceOw.roundTripPrice = "0";
    this.childPriceOw.minAge = "2";
    this.childPriceOw.maxAge = "12";
    this.childPriceOw.quota = this.flightInput.totalQuota;

    this.flightPricesOw.push(
      this.adultPriceOw,
      this.childPriceOw,
      this.infantPriceOw
    );
  }
  createPriceOwRt() {
    this.adultPriceOwRt.flightClass = new FlightClass();
    this.adultPriceOwRt.flightSegment = new FlightSegment();
    this.adultPriceOwRt.passengerType = new PassengerType();
    this.adultPriceOwRt.salesChannel = new FlightSaleChannel();
    this.adultPriceOwRt.flightClass.name = this.isBusinessFlight ? "BUSINESS" : "ECONOMY";
    this.adultPriceOwRt.flightClass.id = this.isBusinessFlight ? "B" : "X";
    this.adultPriceOwRt.flightSegment.name = this.isBusinessFlight ? "Z" : "Y";
    this.adultPriceOwRt.flightSegment.id = this.isBusinessFlight ? "B" : "A";
    this.adultPriceOwRt.passengerType.name = "Adult";
    this.adultPriceOwRt.passengerType.id = 1;
    this.adultPriceOwRt.salesChannel.name = "Internet";
    this.adultPriceOwRt.salesChannel.id = "INTERNET";
    this.adultPriceOwRt.oneWayPrice = "0";
    this.adultPriceOwRt.roundTripPrice = "0";
    this.adultPriceOwRt.minAge = "12";
    this.adultPriceOwRt.maxAge = "99";
    this.adultPriceOwRt.quota = this.flightInputRt.totalQuota;

    this.infantPriceOwRt.flightClass = new FlightClass();
    this.infantPriceOwRt.flightSegment = new FlightSegment();
    this.infantPriceOwRt.passengerType = new PassengerType();
    this.infantPriceOwRt.salesChannel = new FlightSaleChannel();
    this.infantPriceOwRt.flightClass.name = this.isBusinessFlight ? "BUSINESS" : "ECONOMY";
    this.infantPriceOwRt.flightClass.id = this.isBusinessFlight ? "B" : "X";
    this.infantPriceOwRt.flightSegment.name = this.isBusinessFlight ? "Z" : "Y";
    this.infantPriceOwRt.flightSegment.id = this.isBusinessFlight ? "B" : "A";
    this.infantPriceOwRt.passengerType.name = "Infant";
    this.infantPriceOwRt.passengerType.id = 3;
    this.infantPriceOwRt.salesChannel.name = "Internet";
    this.infantPriceOwRt.salesChannel.id = "INTERNET";
    this.infantPriceOwRt.oneWayPrice = "0";
    this.infantPriceOwRt.roundTripPrice = "0";
    this.infantPriceOwRt.minAge = "0";
    this.infantPriceOwRt.maxAge = "2";
    this.infantPriceOwRt.quota = this.flightInputRt.totalQuota;

    this.childPriceOwRt.flightClass = new FlightClass();
    this.childPriceOwRt.flightSegment = new FlightSegment();
    this.childPriceOwRt.passengerType = new PassengerType();
    this.childPriceOwRt.salesChannel = new FlightSaleChannel();
    this.childPriceOwRt.flightClass.name = this.isBusinessFlight ? "BUSINESS" : "ECONOMY";
    this.childPriceOwRt.flightClass.id = this.isBusinessFlight ? "B" : "X";
    this.childPriceOwRt.flightSegment.name = this.isBusinessFlight ? "Z" : "Y";
    this.childPriceOwRt.flightSegment.id = this.isBusinessFlight ? "B" : "A";
    this.childPriceOwRt.passengerType.name = "Child";
    this.childPriceOwRt.passengerType.id = 2;
    this.childPriceOwRt.salesChannel.name = "Internet";
    this.childPriceOwRt.salesChannel.id = "INTERNET";
    this.childPriceOwRt.oneWayPrice = "0";
    this.childPriceOwRt.roundTripPrice = "0";
    this.childPriceOwRt.minAge = "2";
    this.childPriceOwRt.maxAge = "12";
    this.childPriceOwRt.quota = this.flightInputRt.totalQuota;

    this.flightPricesOwRt.push(
      this.adultPriceOwRt,
      this.childPriceOwRt,
      this.infantPriceOwRt
    );
  }

  async price() {
    this.e1 = 4;
  }

  async saveFlight() {
    var flightGeneral = new FlightGeneral();
    flightGeneral.flightPriceGenerals = this.flightPricesOw;
    flightGeneral.flightPeriods = this.flightPeriods;
    flightGeneral.flightNo = this.flightInput.flightNo;
    flightGeneral.airlineCompany = this.flightInput.airlineCompany;
    flightGeneral.code = this.flightInput.code;
    flightGeneral.departureDate = this.flightInput.departureDate;
    flightGeneral.arrivalDate = this.getEndDate;
    flightGeneral.departureHour = this.flightInput.departureHour;
    flightGeneral.arrivalHour = this.flightInput.arrivalHour;
    flightGeneral.duration = this.flightInput.duration;
    flightGeneral.totalQuota = this.flightInput.totalQuota;
    flightGeneral.isActive = this.flightInput.isActive;
    flightGeneral.baggageLimit = this.flightInput.baggageLimit;
    flightGeneral.currency = this.flightInput.currency;
    flightGeneral.fromAirport = this.flightInput.fromAirport;
    flightGeneral.toAirport = this.flightInput.toAirport;
    flightGeneral.packageProvider = this.flightInput.packageProvider;
    // flightQuotas değerlerini isBusinessFlight değişkenine göre güncelleme
    flightGeneral.flightQuotas = [{
      flightClass: {
        name: this.isBusinessFlight ? "BUSINESS" : "ECONOMY",
        code: null,
        pricing: null,
        id: this.isBusinessFlight ? "B" : "X",
      },
      flightSegment: {
        name: this.isBusinessFlight ? "Z" : "Y",
        id: this.isBusinessFlight ? "B" : "A",
      },
      quota: this.flightInput.totalQuota,
    }];
    if (this.flightPricesOwRt.length > 0) {
      flightGeneral.flightRoundTrip = this.flightInputRt;
      flightGeneral.flightRoundTrip.duration = this.flightInputRt.duration;
      flightGeneral.flightRoundTrip.arrivalDate = this.getEndDate2;
      // flightRoundTrip için flightQuotas değerlerini isBusinessFlight değişkenine göre güncelleme
      flightGeneral.flightRoundTrip.flightQuotas = [{
        flightClass: {
          name: this.isBusinessFlight ? "BUSINESS" : "ECONOMY",
          code: null,
          pricing: null,
          id: this.isBusinessFlight ? "B" : "X",
        },
        flightSegment: {
          name: this.isBusinessFlight ? "Z" : "Y",
          id: this.isBusinessFlight ? "B" : "A",
        },
        quota: this.flightInputRt.totalQuota,
      }];
      flightGeneral.flightRoundTrip.flightPriceGenerals = this.flightPricesOwRt;
      flightGeneral.flightRoundTrip.handBaggageLimit = this.flightInputRt.handBaggageLimit;
    }
    flightGeneral.handBaggageLimit = this.flightInput.handBaggageLimit;
    await this.$store
      .dispatch({
        type: "flight/addFlights",
        data: flightGeneral,
      })
      .then((res) => {
        if (res.status === 200) {
          this.dialog = false;
          this.displayAlert = true;
          setTimeout(() => {
            this.$router.push("/");
          }, 2000);
        }
      });
  }
  filterData(item, queryText) {
  
      return (
        item.id.toLowerCase().includes(queryText.toLowerCase()) ||  
        item.name.toLowerCase().includes(queryText.toLowerCase())
      );
    }

  createEvent() {
    let startDate = moment(this.getDepartureDate, "DD/MM/YYYY");
    let endDate = moment(this.getEndDate, "DD/MM/YYYY");
    let startDateRt = moment(this.getDepartureDate2, "DD/MM/YYYY");
    let endDateRt = moment(this.getEndDate2, "DD/MM/YYYY");
    let diff = endDate.diff(startDate, "days", true);
    let diff2 = endDateRt.diff(startDateRt, "days", true);

    if (!this.events.length) {
      for (let index = 0; index < diff + 1; index++) {
        var flightPeriod = new FlightPeriod();
        var date = moment(this.flightInput.departureDate, ["YYYY-MM-DD"]).add(
          index,
          "days"
        );

        let whichDay = date.isoWeekday();
        var include = this.days.includes(whichDay.toString());
        if (include) {
          let event = {
            // name: this.flightDestination + ' ' + this.flightInput.departureHour,
            name: this.flightDestination,
            start: date.format("YYYY-MM-DD"),
            end: date.format("YYYY-MM-DD"),
            color: "cyan",
          };
          flightPeriod.title = this.flightDestination;
          flightPeriod.startsAt = date.format("YYYY-MM-DD");
          flightPeriod.endsAt = date.format("YYYY-MM-DD");
          flightPeriod.flightNo = this.flightInput.flightNo;
          flightPeriod.company = this.flightInput.airlineCompany.name;
          flightPeriod.quota = this.flightInput.totalQuota;
          this.events.push(event);
          this.flightPeriods.push(flightPeriod);
        }
      }
    } else {
      for (let index = 0; index < diff2 + 1; index++) {
        var flightPeriod = new FlightPeriod();
        var date = moment(this.flightInputRt.departureDate, ["YYYY-MM-DD"]).add(
          index,
          "days"
        );

        let whichDay = date.isoWeekday();
        var include = this.days.includes(whichDay.toString());
        if (include) {
          let event = {
            // name: this.flightDestination + ' ' + this.flightInput.departureHour,
            name: this.flightDestination,
            start: date.format("YYYY-MM-DD"),
            end: date.format("YYYY-MM-DD"),
            color: "blue",
          };
          flightPeriod.title = this.flightDestination;
          flightPeriod.startsAt = date.format("YYYY-MM-DD");
          flightPeriod.endsAt = date.format("YYYY-MM-DD");
          this.events.push(event);
          this.flightPeriods.push(flightPeriod);
        }
      }
    }
  }

  endDateEvents(event) {
    if (new Date(event) > new Date(this.flightInput.departureDate)) {
    } else if (new Date(event) <= new Date(this.flightInput.departureDate)) {
      alert("Dönüş Zamanı gidiş zamanından ileri tarih olmalıdır!");
      this.flightInputEd.arrivalDate = "";
    }
  }
  endDateEventsRt(event) {
    if (new Date(event) > new Date(this.flightInputRt.departureDate)) {
    } else if (new Date(event) <= new Date(this.flightInputRt.departureDate)) {
      alert("Dönüş Zamanı gidiş zamanından ileri tarih olmalıdır!");
      this.flightInputEd2.arrivalDate = "";
    }
  }

  handleFromAirport(e) {
    this.flightInputRt.toAirport = e;
  }
  handleToAirport(e) {
    this.flightInputRt.fromAirport = e;
  }

  handleBaggageLimit(e) {
    this.flightInputRt.baggageLimit = e;
  }
  handleQuota(e) {
    this.flightInputRt.totalQuota = e;
  }

  handleCurrency(e) {
    this.flightInputRt.currency = e;
  }

  get getDepartureDate() {
    return this.flightInput.departureDate
      ? moment(this.flightInput.departureDate).format("DD-MM-yyyy")
      : "";
  }
  get getDepartureDate2() {
    return this.flightInputRt.departureDate
      ? moment(this.flightInputRt.departureDate).format("DD-MM-yyyy")
      : "";
  }

  get getEndDate() {
    return this.flightInputEd.arrivalDate
      ? moment(this.flightInputEd.arrivalDate).format("DD-MM-yyyy")
      : "";
  }
  get getEndDate2() {
    return this.flightInputEd2.arrivalDate
      ? moment(this.flightInputEd2.arrivalDate).format("DD-MM-yyyy")
      : "";
  }

  getDurationTime() {
    const startTime = moment(this.flightInput.departureHour, "HH:mm:ss");
    const endTime = moment(this.flightInput.arrivalHour, "HH:mm:ss");
    if (startTime > endTime) {
      const newEnd = endTime.add(moment.duration(24, "hours"));
      const duration = moment.duration(newEnd.diff(startTime));
      const hours = duration.asHours().toFixed(0);
      const minutes = duration.asMinutes() % 60;
      this.flightInput.duration = `${hours}:${minutes}`;
    } else if (startTime < endTime) {
      const duration = moment.duration(endTime.diff(startTime));
      const hours = duration.asHours().toFixed(0);
      const minutes = duration.asMinutes() % 60;
      this.flightInput.duration = `${hours}:${minutes}`;
    }
  }
  getDurationTimeRt() {
    const startTime = moment(this.flightInputRt.departureHour, "HH:mm:ss");
    const endTime = moment(this.flightInputRt.arrivalHour, "HH:mm:ss");
    if (startTime > endTime) {
      const newEnd = endTime.add(moment.duration(24, "hours"));
      const duration = moment.duration(newEnd.diff(startTime));
      const hours = duration.asHours().toFixed(0);
      const minutes = duration.asMinutes() % 60;
      this.flightInputRt.duration = `${hours}:${minutes}`;
    } else if (startTime < endTime) {
      const duration = moment.duration(endTime.diff(startTime));
      const hours = duration.asHours().toFixed(0);
      const minutes = duration.asMinutes() % 60;
      this.flightInputRt.duration = `${hours}:${minutes}`;
    }
  }

  async getFlightProviders() {
    await this.$store.dispatch({
      type: "flightProvider/getFlightProviders",
    });

    this.flightProviders = this.$store.state.flightProvider.list;
  }

  async getAirports() {
    await this.$store.dispatch({
      type: "airport/getAirports",
    });

    this.airports = this.$store.state.airport.list;
  }
  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  }

  async getAirlineCompanies() {
    await this.$store.dispatch({
      type: "airlineCompany/getAirlineCompanies",
    });

    this.airlineCompanies = this.$store.state.airlineCompany.list;
  }

  async getFlightClasses() {
    await this.$store.dispatch({
      type: "flightClass/getFlightClasses",
    });

    this.flightClasses = this.$store.state.flightClass.list;
  }

  async getFlightSegments() {
    await this.$store.dispatch({
      type: "flightSegment/getFlightSegments",
    });

    this.flightSegments = this.$store.state.flightSegment.list;
  }

  async getFlightSaleChannels() {
    await this.$store.dispatch({
      type: "flightSaleChannel/getFlightSaleChannels",
    });

    this.flightSaleChannels = this.$store.state.flightSaleChannel.list;
  }

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
        dropdown: (value) => !!value.id || "Zorunlu Alan.",
      },

      quotaRules: [
        (v) => !!v || "Input is required!",
        (v) => v < +this.flightInput.totalQuota || "Input maxxxx",
      ],

      e1: 1,

      page: 1,
      range: [0, 70],

      flights: [],

      // flightClassItems: ['Economy'],
      // flightClasses: [],

      // flightSegmentItems: ['Y'],
      // flightSegments: [],

      passengerTypeItems: ["Yetişkin", "Çocuk", "Bebek"],
      passengerTypes: [],

      // salesChannelItems: ['Acente', 'İnternet', 'Momondo', 'Skyscanner'],
      // salesChannels: [],

      methodItems: [
        "1 - Sefer Tutar Kuralı",
        "2 - Gidiş Uçuş Kuralı",
        "3 - Sefer Fiyat Kuralı",
      ],
      methods: [],
    };
  }

  mounted() {
    this.calendarInstance.checkChange();
  }

  getEventColor(event) {
    return event.color;
  }
  setToday() {
    this.focus = "";
  }
  prev() {
    this.calendarInstance.prev();
  }
  next() {
    this.calendarInstance.next();
  }

  private get calendarInstance(): Vue & {
    prev: () => void;
    next: () => void;
    checkChange: () => void;
    getFormatter: (format: any) => any;
  } {
    return this.$refs.calendar as Vue & {
      prev: () => void;
      next: () => void;
      checkChange: () => void;
      getFormatter: (format: any) => any;
    };
  }

  nextPage2() {
    if (this.isFlightRt) {
      let airport =
        this.flightInput.fromAirport.id + " - " + this.flightInput.toAirport.id;
      let airport2 =
        this.flightInputRt.fromAirport.id +
        " - " +
        this.flightInputRt.toAirport.id;
      this.flightDestinations.push(airport, airport2);
      this.getDurationTime();
      this.getDurationTimeRt();
      this.e1 = 2;
    } else {
      let airport =
        this.flightInput.fromAirport.id + " - " + this.flightInput.toAirport.id;
      this.flightDestinations.push(airport);
      this.getDurationTime();
      this.e1 = 2;
    }
  }

  @Watch("flightTypes")
  onPropertyChangeFlightTypes(value) {
    if (value == 2) {
      this.createPriceOwRt();
      this.isFlightRt = true;
    }
  }

  handleFlightDestination(e: EventListenerObject) {
    this.index = this.flightDestinations.indexOf(e);
    if (this.index > 0) {
      this.setDepartureDate = this.getDepartureDate2;
    } else {
      this.setDepartureDate = this.getDepartureDate;
    }
  }

  get setEndDates() {
    if (this.index === 1) {
      return this.getEndDate2;
    } else {
      return this.getEndDate;
    }
  }

  handleHandBaggageLimit(e) {
    this.flightInputRt.handBaggageLimit = e;
  }

  handleBusinessFlightChange(value) {
    this.isBusinessFlight = value;
    this.flightPricesOw = [];
    this.flightPricesOwRt = [];
    this.createPriceOw();
    if (this.flightTypes == 2) {
      this.createPriceOwRt();
    }
  }
}
